import { CARES_TYPE_VALUES } from '../../../../constants/constants';
import CaresDiscountOnlySection from './sections/CaresDiscountOnlySection';
import CaresDiscountAndGrantSection from './sections/CaresDiscountAndGrantSection';
import CaresGrantOnlySection from './sections/CaresGrantOnlySection';
import CaresExceptionRequestSection from './sections/CaresExceptionRequestSection';

const CaresTypeRenderer = ({
  form,
  formData,
  setFormField,
  hasExistingCaresData,
  isSubmitting,
}) => {

  switch (form?.caresType) {
    case CARES_TYPE_VALUES.NEWDISCOUNT:
    case CARES_TYPE_VALUES.CHANGEDISCOUNT:
      return <CaresDiscountOnlySection 
          form={form}
          currentEnergyDiscount={formData?.currentDiscountPercentage}
          setFormField={setFormField}
          hasExistingCaresData={hasExistingCaresData}
          isSubmitting={isSubmitting}
        />;
    case CARES_TYPE_VALUES.NEWDISCOUNTANDGRANT:
    case CARES_TYPE_VALUES.CHANGEDISCOUNTANDNEWGRANT:
      return <CaresDiscountAndGrantSection
          form={form}
          currentEnergyDiscount={formData?.currentDiscountPercentage}
          setFormField={setFormField}
          hasExistingCaresData={hasExistingCaresData}
          isSubmitting={isSubmitting}
        />;
    case CARES_TYPE_VALUES.NEWGRANT:
      return <CaresGrantOnlySection 
          arrearsLiabilityAmount={form?.arrearsLiabilityAmount}
          onArrearsLiabilityAmountChange={value => setFormField('arrearsLiabilityAmount', value)}
          incomeMeasurementType={form?.incomeMeasurementType}
          incomeMeasurementPercentage={form?.incomeMeasurementPercentage}
          arrearage={form?.arrearage}
          energyDiscount={form?.energyDiscount}
          pledgeAmount={form?.pledgeAmount}
          isSubmitting={isSubmitting}
        />;
    case CARES_TYPE_VALUES.EXCEPTIONREQUEST:
      return <CaresExceptionRequestSection 
          pledgeAmount={form?.pledgeAmount}
          onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
          exceptionReason={form?.exceptionReason}
          onExceptionReasonChange={value => setFormField('exceptionReason', value)}
          isSubmitting={isSubmitting}
      />;
    default:
      return <></>;
  }
};

export default CaresTypeRenderer;